let makePopulated = [];

if (/Mobi|Android|iPhone|iPad/i.test(navigator.userAgent)) {
    document.querySelector('.mmy-search details').removeAttribute('open')
} else {
    document.querySelector('.mmy-search details').setAttribute('open', '')
}

document.onreadystatechange = () => {
    if (document.readyState === 'complete') {

        let cookies = getCookies();

        if(cookies){

            const make = cookies.make ?? null;
            const model = cookies.model ?? null;
            const year = cookies.year ?? null;

            if(make && model && year){
                setObserver('make',make);
                setObserver('model',model);
                setObserver('year',year);

            } else{

                deleteMmyCookies();
            }
        }

        $("#mmySearchButtonReset").on('click', function () {

            deleteMmyCookies();
        });

        $("#make, #model, #year").on("change", function () {

            hideButtons();

            if ( $(this).attr('id') === 'year' &&  $("#make").val() &&  $("#model").val() &&  $("#year").val() ) {

                showButtons();
            }
        });

        $("#mmySearchButton").on("click", function () {

            const make = $("#make").val() ?? null;
            const model = $("#model").val() ?? null;
            const year = $("#year").val() ?? null;

            if(make && model && year) {

                var mmy = {
                    make: make,
                    model: model,
                    year: year,
                }

                Cookies.set('mmy', JSON.stringify(mmy));

                var dirty = `${ make } ${ model } ${ year } bumper kits`;
                var url = '/collections/' + dirty.toLowerCase()
                    .replace(/ /g, '-')
                    .replace(/[^\w-]+/g, '');

                window.location.href = url;
            } else {

                deleteMmyCookies();
            }
        });

    }
};

function deleteMmyCookies(){

    Cookies.remove('mmy');
    window.location.href = '/';
}

function setObserver(id,value){

    let observer = new MutationObserver(function() {

        let element = document.getElementById(id)
        if (element.options.length > 1) {
                populateDropdownValue(element,value,id)

            observer.disconnect();
            observer = null;
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
}

function populateDropdownValue(element, value,id) {

    element.value = value;
    element.dispatchEvent(new Event("change"));
    makePopulated[id] = element.value ?? null;

    if(makePopulated['make'] && makePopulated['model'] && makePopulated['year']){

        showButtons();
    }
};


function getCookies() {

    return Cookies.get('mmy') ? JSON.parse(Cookies.get('mmy')) : null;
}

function showButtons(){

    $("#mmySearchButton").prop("disabled", false);
    $("#mmySearchButtonReset").show();
}

function hideButtons() {

    $("#mmySearchButton").prop("disabled", true);
    $("#mmySearchButtonReset").hide();
}